import styled, { keyframes } from 'styled-components/macro';
import { Text } from 'components/ui/text';

const RotateLoader = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
`;

export const Wrapper = styled.div`
  background-color: transparent;
  display: flex;
  gap: 8px;
  align-items: center;

  svg {
    animation: ${RotateLoader} 1s 0s linear infinite;
  }
`;

export const TextWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const LoaderText = styled(Text)`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
`;
